export default {
  SET_LOCATIONS_DATA(state, data) {
    state.locations = data;
  },
  SET_COUNTRIES_DATA(state, data) {
    state.countries = data;
  },
  SET_DESTINATIONS_DATA(state, data) {
    state.destinations = data;
  },
};
